export default __webpack_public_path__ + "static/media/Clicking.174c1b72.mp3";